"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveBasketItemEvent = exports.Name = void 0;
const Name = exports.Name = 'remove-basket-item';
const RemoveBasketItemEvent = exports.RemoveBasketItemEvent = Name;
//# sourceMappingURL=index.js.map